exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-body-follow{margin-top:15px}.total-title{text-align:center;font-weight:700}.txt-follow{text-align:center;vertical-align:text-top;color:#9b9b9b}.color-brown{color:brown}.color-red{color:red}.color-green{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a66d070","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/Follow.vue
// module id = 1052
// module chunks = 0